import { autoBatchEnhancer, configureStore } from '@reduxjs/toolkit'
import { createReduxEnhancer as sentryReduxEnhancer } from '@sentry/react'
import thunk from 'redux-thunk'
import { createMigrate, createTransform, persistReducer, persistStore } from 'redux-persist'
import storage from 'redux-persist/lib/storage' //localforage seems to slow rehydration?
import { last } from 'lodash-es'
import reducer from './_rootReducer'
import migrations from './_migrations'
import { setDefaultTimezone } from './Constants'
import { getActiveRestaurant } from './Restaurants'

//https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/redux/
const sentryEnhancer = sentryReduxEnhancer({
	actionTransformer: action => {
		switch (action.type) { // eslint-disable-line default-case
			case 'auth/login':
				action = {
					...action,
					payload: {
						...action.payload,
						token: '-=-REDACTED-=-'
					}
				}
				break
		}
		return action
	}
})

const initialTimezoneSetter = createTransform(null, restaurants => {
	const selected = getActiveRestaurant({ restaurants }) || restaurants[0]
	setDefaultTimezone(selected?.timezone_id)
	return restaurants
}, { whitelist: 'restaurants' })

//this is used to log to our servers the current persistence version
window.localStorage.reduxVersion = last(Object.keys(migrations))
// window.localStorage.reduxVersion = last(Object.keys(migrations)) -1 //go back (no state changes), then toggle back to re-run the migration

const persistenceConfig = {
	storage,
	key      : 'root',
	blacklist: [
		'alerts', //these are not persisted, so we can use React elements inside
		'constants', //make sure we're always using the fresh version (from the server in dev, from the build in prod)
		'request', //that's DEFINITELY ephemeral
	],
	version   : window.localStorage.reduxVersion,
	migrate   : createMigrate(migrations, { debug: false }),
	transforms: [initialTimezoneSetter],
}

//instead of using the default middlewares, we're removing the serializable-state checker, as it conflicts with
// redux-persist: https://github.com/rt2zz/redux-persist/issues/988#issuecomment-465447263
export const store = configureStore({
	reducer   : persistReducer(persistenceConfig, reducer),
	middleware: [thunk],
	enhancers : [sentryEnhancer, autoBatchEnhancer()]
})

export const persistor = persistStore(store)
